import { CreateFlowPayload } from '../../../flows/src/types/ApiTypes';
import { persistState } from '../store/redux/reducers/statePersistence';

/**
 * Because of the bad design of how sales conversation works, we have
 * to store a selection state for it to work correctly later in the flow.
 */
export const setSelectionState = (
  sessionId: string,
  flowPayload: CreateFlowPayload,
) => {
  return persistState('selection', sessionId, () => ({
    selection: {
      selectedRiskObjects: flowPayload.insurance_type || [],
      selectedCompanies: flowPayload.company || [],
      selectedGuarantees: {
        car: flowPayload.car_tag,
        home: flowPayload.home_tag,
        legal: flowPayload.legal_tag,
        family: flowPayload.family_tag,
      },
    },
  }));
};
